<template>
  <div class="home">
    <Restore :appLogo="appLogo" :appTitle="appTitle" />
  </div>
</template>

<script>
// @ is an alias to /src
import Restore from '@/components/Restore.vue'

export default {
  props:['appLogo', 'appTitle' ],
  name: 'RestoreView',
  components: {
    Restore
  }
}
</script>
